// import $ from 'jquery';

class ScrollNext {

	constructor(){
		this.trigger  = document.querySelectorAll('[data-trigger="scroll-next"]');
		this._init();
	}

	_init(){
	  document.addEventListener('DOMContentLoaded', (event) => {

	  	for (let element of this.trigger) {
		    element.addEventListener('click', 
		    	this._scrollToNext.bind(this),
		    	false
		    );
			}

	  });
	}
		
	_scrollToNext(event) {
    const $ = jQuery;
		const scrollOffset = 30;
		const buttonInfos  = Foundation.Box.GetDimensions(this.trigger);
		const buttonBottom = buttonInfos.offset.top + buttonInfos.height + scrollOffset;
		$('html, body').animate({
			scrollTop: buttonBottom
		}, 400);
		event.preventDefault();
	}

}

export const scrollNext = new ScrollNext();